import { render, staticRenderFns } from "./PagesForm.vue?vue&type=template&id=67c18f18&scoped=true"
import script from "./PagesForm.vue?vue&type=script&lang=js"
export * from "./PagesForm.vue?vue&type=script&lang=js"
import style0 from "./PagesForm.vue?vue&type=style&index=0&id=67c18f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c18f18",
  null
  
)

export default component.exports